import script from "./time-setting-ly.vue?vue&type=script&setup=true&lang=js"
export * from "./time-setting-ly.vue?vue&type=script&setup=true&lang=js"

import "./time-setting-ly.vue?vue&type=style&index=0&id=65855a26&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65855a26"]])

export default __exports__